import React from "react";
import { Tag } from "antd";
import useLang from "../../../hooks/useLang";
import { OrderStatusHistoryOverview } from "../../../api/bulk-order-operations";

interface OrderSummaryProps {
	overview: OrderStatusHistoryOverview;
}

const formatDate = (value: string | null) => {
	if (!value) return "—";
	const date = new Date(value);
	return Number.isNaN(date.getTime()) ? "—" : date.toLocaleDateString();
};

const OrderSummary = ({ overview }: OrderSummaryProps) => {
	const { strings } = useLang("bulkOrderOperations");
	const copy = strings?.historyManagement;

	const { summary, isInternational } = overview;

	// Orders carry the pair; showing it raw is more useful than a guessed label on a
	// screen whose whole job is correcting status data.
	const statusPair =
		summary.internationalStatusId != null
			? `(${summary.statusId}, ${summary.internationalStatusId})`
			: `(${summary.statusId})`;

	return (
		<div className="rounded-lg border border-gray-200 p-4 flex flex-col gap-2">
			<div className="flex items-center gap-2 flex-wrap">
				<span className="text-lg font-semibold">
					{summary.displayId ?? `#${overview.orderId}`}
				</span>
				{isInternational ? (
					<Tag color="purple">
						{copy?.international ?? "International"}
					</Tag>
				) : (
					<Tag>{copy?.local ?? "Local"}</Tag>
				)}
			</div>
			<div className="text-sm text-gray-600 flex flex-wrap gap-x-4 gap-y-1">
				<span>
					{copy?.seller ?? "Seller"}: {summary.sellerName ?? "—"}
					{summary.uniqueSellerIdentifier
						? ` (${summary.uniqueSellerIdentifier})`
						: ""}
				</span>
				<span>
					{copy?.buyer ?? "Buyer"}: {summary.buyerName ?? "—"}
				</span>
				<span>
					{copy?.currentStatus ?? "Current status"}: {statusPair}
				</span>
				<span>
					{copy?.created ?? "Created"}:{" "}
					{formatDate(summary.createdAt)}
				</span>
			</div>
		</div>
	);
};

export default OrderSummary;
